module.exports = __webpack_public_path__ + "img/home-z-two.ad7335f3.png";